"use client";

import React from "react";
import { FormControlWrapper } from "../FormControlWrapper";
import { ResourcePickerControl } from "./ResourcePickerControl";
import { ResourcePickerFieldInputProps } from "./ResourcePickerFieldInput.types";

/**
 * A picker form field: the shared label/required/description/error chrome
 * (`FormControlWrapper`) wrapping a `ResourcePickerControl`. Controlled via `isSelected`
 * plus the open/clear callbacks; the actual picker (e.g. a modal) is owned by the consumer.
 */
export const ResourcePickerFieldInput: React.FC<
  ResourcePickerFieldInputProps
> = ({ label, isRequired = false, description, error, ...control }) => (
  <FormControlWrapper
    variant="unstyled"
    label={label}
    isRequired={isRequired}
    helperText={description}
    error={error}
  >
    <ResourcePickerControl {...control} />
  </FormControlWrapper>
);
